import { logNativeSdkEvent, NATIVE_SDK_LOG_EVENTS } from './native-sdk-logs';
import {
  isNativeSdkReturn,
  NATIVE_SDK_RETURN_PARAMS,
  REVOLUT_ORDER_PARAM,
} from '../../helper-functions/native-sdk-return';

// PRX-24667: the `mobile_return` log, the only record of a return by redirect
// (there is no SDK event on the page that opens). The Revolut parameters go
// to the log as received; they are never used as the payment result.
const REVOLUT_RETURN_PARAMS = [REVOLUT_ORDER_PARAM, '_rp_s', '_rp_fr', '_rp_dos'];

export const logNativeSdkMobileReturn = (href?: string | null, loadedData?: any) => {
  try {
    const params = new URL(href || '').searchParams;
    if (!isNativeSdkReturn(params)) return;

    const gatewayId = Number(params.get(NATIVE_SDK_RETURN_PARAMS.Gateway));
    const traceId = loadedData?.transaction?.trace_id;

    logNativeSdkEvent(NATIVE_SDK_LOG_EVENTS.MobileReturn, {
      ...Object.fromEntries(REVOLUT_RETURN_PARAMS.map((name) => [name, params.get(name)])),
      ...(Number.isFinite(gatewayId) && gatewayId > 0 && { gateway_id: gatewayId }),
      ...(traceId !== undefined && traceId !== null && { trace_id: String(traceId) }),
    });
  } catch (e) {
    // a broken return address never breaks the boot
  }
};
